import styled from "styled-components";

export const MainContainer = styled.div`

  display: flex;
  background-color: #FFFFFF;
`;
